// extracted by mini-css-extract-plugin
export default {"formPanel":"userTabs_formPanel__ZTEVf","customInput":"userTabs_customInput__d1NW7","Mui-focused":"userTabs_Mui-focused__4PKTL"};